<template>
  <li class="LatterBlockCassette">
    <div class="LatterBlockCassette_hospital">
      <div class="header">
        <div class="left">
          <HeadingLv3 :text="detail.hospital_name" />
          <HospitalLabel :items="labels" class="labels" />
        </div>
        <div class="img">
          <img
            :src="
              detail.basicinfo_image1 ||
                require(`@/assets/images/common/noimg.svg`)
            "
            :alt="detail.hospital_name"
          />
        </div>
      </div>
      <div class="info">
        <div class="hospitalCassette_about">
          <dl
            class="hospitalCassette_data"
            v-if="detail.prefectures && detail.hospital_address"
          >
            <dt>所在地</dt>
            <dd>{{ detail.prefectures }}{{ detail.hospital_address }}</dd>
          </dl>
          <dl class="hospitalCassette_data" v-if="detail.hospital_class">
            <dt>病院種別</dt>
            <dd>
              <span>{{ detail.hospital_class }}</span>
            </dd>
          </dl>
          <dl class="hospitalCassette_data" v-if="data.bedNum">
            <dt>病床数</dt>
            <dd>{{ data.bedNum }}</dd>
          </dl>
          <dl class="hospitalCassette_data" v-if="data.doctorNum">
            <dt>医師数</dt>
            <dd>{{ data.doctorNum }}</dd>
          </dl>
        </div>
        <div class="img">
          <img
            :src="
              detail.basicinfo_image1 ||
                require(`@/assets/images/common/noimg.svg`)
            "
            :alt="detail.hospital_name"
          />
        </div>
      </div>
    </div>
    <div class="LatterBlockCassette_link">
      <TextLink
        :link="`/search/hospital/detail/${detail.hospital_id}?tab=latter`"
        :text="`すべてのプログラムを見る (${detail.specialist_total_num})`"
      />
    </div>

    <LatterBlockCassetteProgram
      v-for="specialist in detail.specialist"
      :hospitalId="detail.hospital_id"
      :data="specialist"
      :key="specialist.s_training_id"
    />

    <div class="LatterBlockCassette_link -isBottom">
      <TextLink
        :link="`/search/hospital/detail/${detail.hospital_id}?tab=latter`"
        :text="`すべてのプログラムを見る (${detail.specialist_total_num})`"
      />
    </div>
  </li>
</template>

<script lang="ts">
import { reactive, computed, defineComponent } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import TextLink from '@/components/elements/TextLink.vue'
import LatterBlockCassetteProgram from '@/components/block/LatterBlockCassetteProgram.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    HeadingLv3,
    HospitalLabel,
    TextLink,
    LatterBlockCassetteProgram
  },

  setup(props) {
    const data = reactive({
      bedNum: props.detail.bed_num
        ? numberFormatAddComma(props.detail.bed_num) + '床'
        : '',
      doctorNum: props.detail.doctor_num
        ? numberFormatAddComma(props.detail.doctor_num) + '人'
        : ''
    })

    const labels = computed(() => {
      const res = []
      if (props.detail?.prefectures) res.push(props.detail.prefectures)
      if (props.detail?.junior > 0) res.push('初期研修')
      if (props.detail?.specialist?.length) res.push('専門研修')
      return res
    })

    return {
      data,
      labels
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.LatterBlockCassette {
  margin-right: -16px;
  margin-left: -16px;
  border-top: 1px solid #e4e4e4;
  padding: 24px 16px;

  @include mixins.media() {
    margin-right: 0;
    margin-left: 0;
    padding: 30px 0;
  }

  &_link {
    margin-top: 30px;
    text-align: center;
    @include mixins.media() {
      margin-top: 40px;
    }
    &.-isBottom {
      margin-top: 20px;
    }
  }
}

.LatterBlockCassette_hospital {
  .header {
    .img {
      display: none;
    }

    @include mixins.media() {
      position: relative;
      .left {
        width: calc(74.8% - 20px);
      }
      .img {
        display: block;
        width: 25.2%;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  .labels {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 16px;
    }
  }

  .info {
    margin-top: 16px;
    position: relative;
    overflow: hidden;

    .img {
      position: absolute;
      width: 70px;
      top: 0;
      right: 0;

      @include mixins.media() {
        display: none;
      }
    }
  }
}

.hospitalCassette {
  &_about {
    margin-top: -6px;
    padding-right: 70px;
    line-height: 1.5;

    @include mixins.media() {
      display: flex;
      flex-wrap: wrap;
      width: 74.8%;
      padding-right: 0;
    }

    dt {
      flex-basis: 80px;
      flex-shrink: 0;
      font-weight: 500;
    }

    dd {
      color: #666;
      padding-right: 30px;
    }
  }

  &_data {
    display: flex;
    margin-top: 6px;

    @include mixins.media() {
      font-size: 1.4rem;
      flex-basis: 66.6%;
      max-width: 66.6%;

      &:nth-child(1) {
        order: 1;
      }
      &:nth-child(2) {
        order: 3;
      }
      &:nth-child(3) {
        order: 2;
      }
      &:nth-child(4) {
        order: 4;
      }
      &:nth-child(3),
      &:nth-child(4) {
        flex-basis: 33.3%;
        max-width: 33.3%;
        margin-left: auto;

        dt {
          flex-basis: 70px;
        }
      }
    }
  }
}
</style>
